import { useEffect, useState } from 'react'
import api from '../services/api'

interface Cache {
  cst: Map<string, string>       // ibs01_cod -> ibs01_des
  classTrib: Map<string, string> // `${ibs02_cst}|${ibs02_cod}` -> ibs02_des
}

// Carrega frota.ibs001 (CST) e frota.ibs002 (cClassTrib) uma única vez por sessão
// (cache em módulo, não por componente) e reaproveita entre Lançamento de Notas e
// Consulta — as duas telas só precisam do código pra mostrar a descrição ao lado.
let cachePromise: Promise<Cache> | null = null

async function carregarCache(): Promise<Cache> {
  const [r1, r2] = await Promise.all([
    api.get('/erp/ibs001/lista'),
    api.get('/erp/ibs002/lista'),
  ])
  const cst = new Map<string, string>()
  for (const c of r1.data) cst.set(String(c.ibs01_cod).trim(), String(c.ibs01_des).trim())
  const classTrib = new Map<string, string>()
  for (const c of r2.data) classTrib.set(`${String(c.ibs02_cst).trim()}|${String(c.ibs02_cod).trim()}`, String(c.ibs02_des).trim())
  return { cst, classTrib }
}

export function useIbsCbsDescricoes() {
  const [cache, setCache] = useState<Cache | null>(null)

  useEffect(() => {
    if (!cachePromise) cachePromise = carregarCache()
    cachePromise.then(setCache).catch(() => {})
  }, [])

  function cstDes(cod?: string): string {
    if (!cod) return ''
    return cache?.cst.get(String(cod).trim()) ?? ''
  }
  function classTribDes(cst?: string, cod?: string): string {
    if (!cst || !cod) return ''
    return cache?.classTrib.get(`${String(cst).trim()}|${String(cod).trim()}`) ?? ''
  }

  return { cstDes, classTribDes }
}
